const PrintInvoice = () => {
  return (
    <>




<div
  style={{
    width: "900px",
    margin: "10px auto",
    padding:"20px",
    backgroundColor: "#fff",
    color: "#000",
  }}
>
  <table style={{ width: "100%" }} className="table table-bordered">
    <tbody>
      <tr>
        <td colSpan={4} style={{ textAlign: "center" }}>
          <h3 style={{ fontSize: "20px" }}>Invoice</h3>
          <h3 style={{ fontSize: "20px" }}>SHAHPURA HAVELI, SHAHPURA</h3>
          <p>
            <b>GSTIN No</b> : 08AGWPS9134M2Z8, AGWPS9134M
          </p>
          <p>
            MOTI MAHAL CHAUPAR, SHAHPURA, SHAHPURA, RAJASTHAN, 303103, India
          </p>
          <p>
            <b>Phone</b> : 78913 33399, <b>E-mail</b> : reservations@shahpura.com,
            <b> URL</b> : http://www.shahpura.com/
          </p>
        </td>
      </tr>

      <tr>
        <td>
          <p>
            <b>Folio No. / ResNo</b> : 973 / 814
          </p>
          <p>
            <b>Invoice No</b> : 813
          </p>
          <p>
            <b>Guest Name</b> : Ms. LILIANA SILVIA BIGNOLI SEWARD / Mr. Alberto
            Juffe Stein
          </p>
          <p>
            <b>Bill To</b> : TRANS INDIA HOLIDAYS PRIVATE LIMITED
          </p>
          <p>
            <b>Bill To Address</b> : NEW DELHI
          </p>
          <p>
            <b>Bill To GSTIN No</b> : 07AAACG0264D1Z6
          </p>
          <p>
            <b>Source</b> : TRANS INDIA HOLIDAYS PRIVATE LIMITED
          </p>
          <p>
            <b>Source Of Supply</b> : SHAHPURA
          </p>
        </td>

        <td>
          <p>
            <b>G.R. Card No</b> : 321
          </p>
          <p>
            <b>Date of Invoice</b> : 21/02/2025 13:28:07
          </p>
          <p>
            <b>Room</b> : Zenana Suites / 206
          </p>
          <p>
            <b>No of Person</b> : 2 (A) / 0 (C)
          </p>
          <p>
            <b>Rate Type</b> : With Breakfast, Lunch or Dinner
          </p>
          <p>
            <b>No of Nights</b> : 2
          </p>
          <p>
            <b>Date of Arrival</b> : 20/02/2025 11:56:23
          </p>
          <p>
            <b>Date of Departure</b> : 21/02/2025 13:28:07
          </p>
        </td>
      </tr>
    </tbody>
  </table>

  {/* =========== TABLE 2 ================ */}

  <table style={{ width: "100%" }} className="table table-bordered">
    <thead>
      <tr>
        <th>Sr No</th>
        <th>Particular</th>
        <th>HSN/SAC</th>
        <th>Qty</th>
        <th style={{ textAlign: "right" }}>Rate</th>
        <th style={{ textAlign: "right" }}>Total</th>
        <th style={{ textAlign: "right" }}>Discount</th>
        <th style={{ textAlign: "right" }}>Taxable</th>
        <th style={{ textAlign: "right" }}>SGST</th>
        <th style={{ textAlign: "right" }}>CGST</th>
        <th style={{ textAlign: "right" }}>IGST</th>
        <th style={{ textAlign: "right" }}>CESS</th>
      </tr>
    </thead>

    <tbody>
      <tr>
        <td>01</td>
        <td>Room Charges</td>
        <td>996311</td>
        <td>1</td>
        <td style={{ textAlign: "right" }}>8,305.08</td>
        <td style={{ textAlign: "right" }}>8,305.08</td>
        <td style={{ textAlign: "right" }}>0.00</td>
        <td style={{ textAlign: "right" }}>8,305.08</td>
        <td style={{ textAlign: "right" }}>
          747.46 <br /> 9.00%
        </td>
        <td style={{ textAlign: "right" }}>
          747.46 <br /> 9.00%
        </td>
        <td style={{ textAlign: "right" }}>
          0.00 <br /> 0%
        </td>
        <td style={{ textAlign: "right" }}>0.00</td>
      </tr>

      <tr style={{ textAlign: "right" }}>
        <td colSpan={5}>
          <b>Total</b>
        </td>
        <td>8,305.08</td>
        <td>0.00</td>
        <td>8,305.0</td>
        <td>747.46</td>
        <td>747.46</td>
        <td>0.00</td>
        <td>0.00</td>
      </tr>
    </tbody>
  </table>

  {/* =================== PAYMENT SECTION =================== */}

  <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
    <div style={{ width: "360px", padding: "20px" }}>
      <h3 style={{ fontSize: "20px", margin: "0" }}>Total Payable Amount</h3>
      <p style={{ fontSize: "15px", margin: "5px 0 13px 0" }}>Nine thousand eight hundred</p>

      <table style={{ width: "100%", marginBottom: "0"}} className="table table-bordered">
        <tbody>
          <tr>
            <th>Payment Date</th>
            <th>Description</th>
            <th>Amount</th>
          </tr>
          <tr>
            <td>21/02/2025</td>
            <td>TRANS INDIA HOLIDAYS PRIVATE LIMITED</td>
            <td>9,800.00</td>
          </tr>
          <tr>
            <th colSpan={2} style={{ textAlign: "right" }}>
              Total
            </th>
            <th>9800.0</th>
          </tr>
        </tbody>
      </table>
    </div>

    <div style={{ width: "497px", textAlign: "right" }}>
      <table style={{ width: "100%" }} className="table table-bordered">
        <tbody><tr>
                        <th colspan="4">Total Charges(Rs) :</th>
                        <th>2600.00</th>
                    </tr>
                    <tr>
                        <th colspan="4">Output CGST 0% :</th>
                        <td>20.20</td>
                    </tr>
                    <tr>
                        <th colspan="4">Total Discount(Rs) :</th>
                        <td>20.20</td>
                    </tr>
                    <tr>
                        <th colspan="4">Total SGST(Rs) :</th>
                        <td>20.20</td>
                    </tr>
                    <tr>
                        <th colspan="4">Total CGST(Rs) :</th>
                        <td>20.20</td>
                    </tr>
                    <tr>
                        <th colspan="4">Total IGST(Rs) :</th>
                        <td>20.20</td>
                    </tr>
                    <tr>
                        <th colspan="4">Total Other Tax(Rs) :</th>
                        <th>20.20</th>
                    </tr>
                    <tr>
                        <th colspan="4">Total Balance Transfer(Rs) :</th>
                        <td>20.20</td>
                    </tr>
                    <tr>
                        <th colspan="4">Total(Rs) :</th>
                        <th>20.20</th>
                    </tr>
                    <tr>
                        <th colspan="4">Flat Discount(Rs) :</th>
                        <td>20.20</td>
                    </tr>
                    <tr>
                        <th colspan="4">Adjustment(Rs) :</th>
                        <td>20.20</td>
                    </tr>
                    <tr>
                        <th colspan="4">Total Payable(Rs) :</th>
                        <td>20.20</td>
                    </tr>
                    <tr>
                        <th colspan="4">Total Payment(Rs) :</th>
                        <td>20.20</td>
                    </tr>
                    <tr>
                        <th colspan="4">Balance(Rs) :</th>
                        <th>20.20</th>
                    </tr>
                </tbody>
      </table>
    </div>
  </div>

  {/* FOOTER ROW */}

  <div
    style={{
      width: "100%",
      padding: "30px 0",
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      justifyContent: "space-between",
    }}
  >
    <div style={{ width: "450px", textAlign: "left" }}>
      <h6>Remarks</h6>
    </div>

    <div style={{ width: "450px", textAlign: "right" }}>
      <h6>Guest Signatory</h6>
    </div>
  </div>
</div>


    </>
  );
};

export default PrintInvoice;
